export default __webpack_public_path__ + "assets/icons/message_success.d008ba4f.svg";